import React from 'react';
import StatusLabel from './StatusLabel';
import loadingIcon from '/src/assets/images/button/loading-circle-2.svg?url';
import acceptedIcon from '/src/assets/images//button/vector.svg?url';
import cancelIcon from '/src/assets/images//button/cancel.svg?url';
import uncompleteIcon from '/src/assets/images/button/uncompleted.svg?url';

export const PendingStatus: React.FC = () => (
  <StatusLabel
    label="درحال بررسی"
    backgroundColor="rgba(252, 118, 43, 0.1)"
    textColor="#FC762B"
    icon={
      <img
        src={loadingIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export const AcceptedStatus: React.FC = () => (
  <StatusLabel
    label="تایید شده"
    backgroundColor="#DBFFF0"
    textColor="#139961"
    icon={
      <img
        src={acceptedIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export const CancelStatus: React.FC = () => (
  <StatusLabel
    label="ردشده"
    backgroundColor="#FFD6DB"
    textColor="#EF4056"
    icon={
      <img
        src={cancelIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export const UncompleteStatus: React.FC = () => (
  <StatusLabel
    label="تکمیل نشده"
    backgroundColor="#E5E5E8"
    textColor="#60646E"
    icon={
      <img
        src={uncompleteIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);
